export default "__VITE_ASSET__DrbnO3Kx__"